import { patchEvent, postEvent } from "@/services/api/eventos";
import { parseBrazilianDate } from "@/utils/string";
export async function submitEventForm({ isEdit, id, accessToken, data, }) {
    const listaAnexo = data.files.map(({ id: fileId, file }) => ({
        tipo: file.type.startsWith("image/") ? "FOTO" : "VIDEO",
        ...(fileId ? { id: fileId } : { anexo: file }),
    }));
    if (isEdit) {
        const value = data;
        const patchPayload = {
            id,
            latitude: value.latitude.replace(/^(-?\d+\.\d{0,14}).*$/, "$1"),
            longitude: value.longitude.replace(/^(-?\d+\.\d{0,14}).*$/, "$1"),
            observacao: value.observacao,
            cidade: value.cidade,
            bairro: value.bairro,
            listaAnexo,
        };
        await patchEvent(patchPayload, accessToken);
        return;
    }
    const value = data;
    const postPayload = {
        categoriaEvento: value.categoriaEvento,
        subcategoriaEventos: value.subcategoriaEventos,
        dataEvento: parseBrazilianDate(value.dataEvento),
        horaEvento: value.horaEvento,
        cidade: value.cidade,
        bairro: value.bairro,
        latitude: value.latitude.replace(/^(-?\d+\.\d{0,14}).*$/, "$1"),
        longitude: value.longitude.replace(/^(-?\d+\.\d{0,14}).*$/, "$1"),
        observacao: value.observacao,
        listaAnexo,
    };
    await postEvent(postPayload, accessToken);
}
